import React from "react";
import PropTypes from "prop-types";
import { Grid, GridItem, Display3, Checkbox } from "@sainsburys-tech/fable";
import * as styles from "./AlertFilter.styles";

const AlertFilter = props => (
  <div className="cb-c-alert-filter">
    <div>
      <Grid cols={1}>
        <GridItem>
          <div className="fable:mt-2">
            <Display3 as="h3" style={styles.filterHeading}>Filter Alerts</Display3>
          </div>
        </GridItem>
      </Grid>
    </div>
    <div>
      <label style={{ fontWeight: 'bold' }}>Status</label>
      {props.alertStatuses.map(status => {
        return (
          <Grid key={status.code} cols={{ xs: 5, md: 5 }} gap="md">
            <GridItem colSpan={4}>
              <Checkbox
                name={status.code}
                label={status.description}
                isDisabled={props.disableCheckboxes ? true : false}
                isChecked={props.activeStatus.includes(status.code)}
                checked={props.activeStatus.includes(status.code)}
                onChange={(checked) => props.onFilterChange({ target: { name: status.code, checked } })}
              />
            </GridItem>
            <GridItem colSpan={1}
              className={
                props.activeStatus.includes(status.code)
                  ? "cb-c-alert-filter__is-active"
                  : ""
              }
            >
              <div className="fable:mb-4">
                <div>
                  {status.code !== "Closed" ? status.count : ""}
                </div>
              </div>
            </GridItem>
          </Grid>
        );
      })}
    </div>
  </div>
);

AlertFilter.propTypes = {
  alertStatuses: PropTypes.array.isRequired,
  activeStatus: PropTypes.array,
  onClick: PropTypes.func,
  onFilterChange: PropTypes.func,
  disableCheckboxes: PropTypes.bool
};

export default AlertFilter;
